import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { AppServiceService } from 'src/app/core/services/app-service.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  links: any;
  buttons: any= [];
  loginType:string;
  phoneSupport:string="";
  constructor(private appConfigService: AppConfigService , private appService: AppServiceService) { }

  ngOnInit(): void {
    this.loginType = this.appService.loginType;
    this.appConfigService.getLinks().subscribe(    
      (data) => { 
        this.links = data[this.loginType];
      },
      (error) => {
        //TODO
      })
      this.appConfigService.getPhoneSupport().subscribe(    
        (data) => { 
          this.phoneSupport = data;
        },
        (error) => {
          //TODO
        })
if(this.phoneSupport !="" && this.loginType!= "OtpOnlyLogin" && this.loginType !="SBSLogin"){
    this.buttons.push(  {
      icon: 'headset.svg',
      text: 'מרכז שירות ומידע ארצי',
      text2: this.phoneSupport
    });
  }
    if (this.links!=undefined){
      if(this.links.informationalVideo){
        this.buttons.push({
              icon: 'play-movie.svg',
              text: 'סרטון הסברה',
              link: this.links.informationalVideo,
              ariaLable: "הפעלת סרטון הדרכה"
            });
      }
      if(this.links.userGuide){
        this.buttons.push({
          icon: 'guide-computer.svg',
          text: 'מדריך למשתמש',
          link:this.links.userGuide,
          ariaLable: "מדריך למשתמש" 
        });
      }
    }

  
}

  openLink(button: any) {
    if (button.link != undefined)
      window.open(button.link)
  }
}
